import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertSchedulingEventsToCalender } from "../../../components/util/helpers";
import moment from "moment";
import Approval from "../../employeeScheduling/components/ApprovalModal";
import { loadPage } from "../../employeeScheduling/schedulingSlice";
import { reset } from "../../employeeDetails/employeeDetailsSlice";
import { listHolidays } from "../../../api/server";
import { loadAbsences } from "../../employeeAbsences/employeeAbsencesSlice";

const ApprovalModal = (props) => {
  const { visible, onHide, initialDate } = props;
  const [currentDate, setCurrentDate] = useState(
    moment().subtract(1, "months")
  );
  const [events, setEvents] = useState([]);
  const [originalEvents, setOriginalEvents] = useState([]);
  const [activeEvent, setActiveEvent] = useState(null);
  const [ordersIds, setOrdersIds] = useState([]);
  const [patientsPallette, setPatientsPallette] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [holidays, setHolidays] = useState([]);
  const absences = useSelector((state) => state.employeeAbsences.absences);

  const loadLoading = useSelector(
    (state) => state.pendingActions["employeeScheduling/load"]
  );

  const activeEmployee = useSelector(
    (state) => state.employeeDetails.activeEmployee
  );

  const { page: schedulingPage } = useSelector(
    (state) => state.employeeScheduling
  );
  const { items, order_time_extractions } = schedulingPage;

  const dispatch = useDispatch();
  useEffect(() => {
    if (initialDate) {
      setCurrentDate(moment(initialDate));
    }
  }, [initialDate, visible]);

  const onHideApprovalModal = () => {
    onHide();
    setCurrentDate(moment().subtract(1, "months"));
    convertItems();
    setFilteredOrders([]);
    dispatch(reset());
  };

  const pallette = [
    {
      primary: "#53C31A",
      border: "#C8D7C2",
      bg: "#F1FBEE",
    },
    {
      primary: "#F99646",
      border: "#F6BD8D",
      bg: "#FDEEE0",
    },
    {
      primary: "#6C64FE",
      border: "#D8D6FC",
      bg: "#F2EFFF",
    },
  ];
  useEffect(() => {
    if (visible) {
      reload();
    }
  }, [activeEmployee, currentDate, visible]);

  useEffect(() => {
    if (visible) {
      const filter = {
        $and: [
          {
            date: {
              $gte: moment(currentDate).startOf("month").format(),
            },
          },
          {
            date: {
              $lte: moment(currentDate).endOf("month").format(),
            },
          },
        ],
      };
      listHolidays({ filter }).then(({ error, data }) => {
        if (data) {
          setHolidays(data.items);
        }
      });
    }
    setFilteredOrders([]);
  }, [dispatch, currentDate, activeEmployee]);

  const reload = () => {
    const startDate = moment(currentDate).startOf("month");
    var endDate = moment(currentDate).endOf("month");
    dispatch(
      loadPage({
        filter: {
          date: {
            $gt: startDate.format(),
            $lt: endDate.format(),
          },
        },
        query: {
          from: startDate.format(),
          end: endDate.format(),
        },
      })
    );
    if (activeEmployee.id) {
      dispatch(loadAbsences(activeEmployee.id));
    }
  };

  useEffect(() => {
    const ids = [...new Set(events.map((obj) => obj.order.id))];
    setOrdersIds(ids);
    let idsPallette = [];
    ids.forEach((item, i) => {
      idsPallette.push({
        orderId: ids[i],
        primary: pallette[i] ? pallette[i].primary : "#53C31A",
        border: pallette[i] ? pallette[i].border : "#C8D7C2",
        bg: pallette[i] ? pallette[i].bg : "#F1FBEE",
      });
    });
    setPatientsPallette(idsPallette);
  }, [events]);

  useEffect(() => {
    convertItems();
    setActiveEvent(null);
  }, [items]);

  const convertItems = () => {
    const convertedToCalender = convertSchedulingEventsToCalender(items);
    setEvents(convertedToCalender);
    setOriginalEvents(convertedToCalender);
  };

  const changeEvents = (arr) => {
    setEvents(arr);
  };

  const onFilterPatientsChanged = (patientId, val) => {
    const newFiltered = val
      ? filteredOrders.filter((item) => item !== patientId)
      : [...filteredOrders, patientId];
    setFilteredOrders(newFiltered);
  };

  const onNextMonth = () => {
    setCurrentDate(moment(currentDate).add(1, "months").startOf("month"));
  };
  const onPreviousMonth = () => {
    setCurrentDate(moment(currentDate).subtract(1, "months").startOf("month"));
  };

  const calenderEvents = activeEvent
    ? [
        ...events.filter((item) => item.id !== activeEvent.id),
        { ...activeEvent },
      ]
    : events;
  return (
    <Approval
      onHide={onHideApprovalModal}
      visible={visible}
      currentDate={currentDate}
      onFilterPatientsChanged={onFilterPatientsChanged}
      onNextMonth={onNextMonth}
      onPreviousMonth={onPreviousMonth}
      filteredOrders={filteredOrders}
      events={calenderEvents}
      originalEvents={originalEvents}
      loadLoading={loadLoading}
      ordersIds={ordersIds}
      patientsPallette={patientsPallette}
      reload={reload}
      changeEvents={changeEvents}
      holidays={holidays}
      order_time_extractions={order_time_extractions}
      absences={absences}
    />
  );
};

export default ApprovalModal;
